/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramProductsUserControllerCreateMutationRequest,
  TelegramProductsUserControllerCreateMutationResponse,
  TelegramProductsUserControllerCreate401,
  TelegramProductsUserControllerCreate402,
  TelegramProductsUserControllerCreate404,
  TelegramProductsUserControllerCreate409,
} from '../types/TelegramProductsUserControllerCreate.ts';

function getTelegramProductsUserCreateUrl() {
  const res = { method: 'POST', url: `/api/user/telegram/products` as const };
  return res;
}

/**
 * {@link /api/user/telegram/products}
 */
export async function telegramProductsUserCreate(
  data: TelegramProductsUserControllerCreateMutationRequest,
  config: Partial<RequestConfig<TelegramProductsUserControllerCreateMutationRequest>> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    TelegramProductsUserControllerCreateMutationResponse,
    ResponseErrorConfig<
      | TelegramProductsUserControllerCreate401
      | TelegramProductsUserControllerCreate402
      | TelegramProductsUserControllerCreate404
      | TelegramProductsUserControllerCreate409
    >,
    TelegramProductsUserControllerCreateMutationRequest
  >({ method: 'POST', url: getTelegramProductsUserCreateUrl().url.toString(), data: requestData, ...requestConfig });
  return res.data;
}
